/// <reference path="../include.ts" />

namespace project_guide {

	import CurrentState = project_common.CurrentState;

	export class SceneTransferMessage {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(currentState:CurrentState, scroll:boolean, smoothScroll:boolean) {
			this.currentState = currentState;
			this.scroll = scroll;
			this.smoothScroll = smoothScroll;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public readonly currentState:CurrentState;
		public readonly scroll:boolean;
		public readonly smoothScroll:boolean;
	}
}
